import { createContext, useContext } from 'react';
import * as React from 'react';
import noop from '@sdk/utils/noop';

import { NewsfeedBridgeState } from '@web/newsfeed/NewsfeedBridgeProvider/newsfeedBridgeProvider.types';

type Props = {
  children: React.ReactNode;
  newsfeedBridge: NewsfeedBridgeState;
};

export const NewsfeedBridgeStateContext = createContext<NewsfeedBridgeState>({
  getPageMemberIds: () => [],
  getPageMembersCount: () => 0,
  onAddComment: noop,
  onAddArticleLike: noop,
  onDeleteComment: noop,
  onRemoveArticleLike: noop,
} as NewsfeedBridgeState);
export const useNewsfeedBridge = () => useContext(NewsfeedBridgeStateContext);

export const NewsfeedBridgeProvider = ({ newsfeedBridge, children }: Props) => (
  <NewsfeedBridgeStateContext.Provider value={newsfeedBridge}>
    {children}
  </NewsfeedBridgeStateContext.Provider>
);
